import { render, staticRenderFns } from "./UnfinishedAddresses.vue?vue&type=template&id=bec19108&"
import script from "./UnfinishedAddresses.vue?vue&type=script&lang=js&"
export * from "./UnfinishedAddresses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/project/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VPagination } from 'vuetify/lib'
import { VSwitch } from 'vuetify/lib'
installComponents(component, {VCard,VCardText,VPagination,VSwitch})
